import { i18next } from '@frontend/i18n';

export const ONLINE_SCHEDULING_VIDEO_URL = 'https://fast.wistia.com/embed/medias/bl2mqg4pea';
export const ONLINE_SCHEDULING_PRICE = 49;
export const ONLINE_SCHEDULING_ONBOARDING_URL =
  'https://getweave.chilipiper.com/book/upsell?type=64ff8c1d1c5178020e8bb297&back=true';
export const ONLINE_SCHEDULING_FEATURE_NAME = i18next.t('Online Scheduling', { ns: 'featurePromotion>>feature' });
